import { principles } from '@/mocks/principles';

export default function FactsSection() {
  return (
    <section id="facts" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-zoom-in-line text-sm"></i> 真相梳理
            </span>
            <h2 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">面对纷杂信息，我们如何分辨真相</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              热点背后最不缺的就是情绪与猜测。海角吃瓜的使命，是把一件事的前因后果放到时间轴上，
              用客观的分级标准标出每条信息的可信度——能确认的我们说清楚，不能确认的我们也如实说明。
            </p>
            <div className="mt-8 space-y-3">
              {[
                ['ri-checkbox-circle-line', '已确认事实', '有官方说明或一手证据支撑，可放心采信。', 'text-secondary-800'],
                ['ri-archive-line', '多方佐证', '多条独立渠道交叉印证，可信度较高但需留意语境。', 'text-secondary-800'],
                ['ri-alert-line', '存有分歧', '各方说法存在出入，我们并列呈现并标注差异点。', 'text-primary-800'],
                ['ri-question-line', '待核实 / 已澄清', '仍在核实中或已被权威渠道证伪，务必谨慎转发。', 'text-primary-800'],
              ].map(([icon, title, desc]) => (
                <div key={title as string} className="flex items-start gap-3 rounded-lg bg-background-100 p-4">
                  <i className={`mt-0.5 text-xl ${icon}`}></i>
                  <div>
                    <div className="text-sm font-bold text-foreground-950">{title}</div>
                    <div className="mt-1 text-sm text-foreground-600">{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {principles.map((p) => (
              <article key={p.id} className="rounded-lg bg-background-100 p-5 transition-colors hover:bg-background-200/70">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <h3 className="heading-font mt-4 text-base font-bold text-foreground-950">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}